/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Module containing dataGrid related components
 * @preferred
 * @module DataGridModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { A11yModule } from '@angular/cdk/a11y';

import {
    ClrCheckboxModule,
    ClrDatagridModule,
    ClrDropdownModule,
} from '@clr/angular';

import { TimeframeSelectorComponent } from 'standalone-components/timeframe-selector';
import { MetricValuesSelectorComponent } from 'standalone-components/metric-values-selector';
import { DialogModule } from '../dialog/dialog.module';
import { SharedModule } from '../../shared/shared.module';

import {
    AviCollectionDataGridComponent,
    AviDataGridBaseComponent,
    AviDataGridColumnSelectionComponent,
    AviDataGridComponent,
    AviDataGridDropdownFilterComponent,
    AviDiffGridComponent,
    AviDynamicDataGridComponent,
    MoveDataGridRowComponent,
    MoveDataGridRowService,
} from '.';

import {
    AviMetricsCellComponent,
} from './components/avi-metrics-collection-data-grid/avi-metrics-cell/avi-metrics-cell.component';
import {
    AviMetricsCollectionDataGridComponent,
} from './components/avi-metrics-collection-data-grid/avi-metrics-collection-data-grid.component';

import { AviDiffGridRowsPipe } from './components/avi-diff-grid/avi-diff-grid-rows.pipe';
import { NormalizeMetricsCellDataPipe } from './pipes/normalize-metrics-cell-data.pipe';
import { ToFixedPipe } from './pipes/to-fixed.pipe';

const dataGridComponents = [
    AviDataGridColumnSelectionComponent,
    AviDataGridComponent,
    AviDataGridBaseComponent,
    AviDiffGridComponent,
    AviDynamicDataGridComponent,
    AviCollectionDataGridComponent,
    AviMetricsCellComponent,
    AviMetricsCollectionDataGridComponent,
    AviDataGridDropdownFilterComponent,
    MoveDataGridRowComponent,
];

const pipes = [
    AviDiffGridRowsPipe,
    NormalizeMetricsCellDataPipe,
    ToFixedPipe,
];

@NgModule({
    declarations: [
        ...dataGridComponents,
        ...pipes,
    ],
    exports: [
        AviCollectionDataGridComponent,
        AviDataGridComponent,
        AviDiffGridRowsPipe,
        AviDynamicDataGridComponent,
        AviDiffGridComponent,
        AviMetricsCellComponent,
        AviMetricsCollectionDataGridComponent,
    ],
    imports: [
        A11yModule,
        ClrDatagridModule,
        ClrCheckboxModule,
        CommonModule,
        DragDropModule,
        FormsModule,
        SharedModule,
        DialogModule,
        ClrDropdownModule,
        ReactiveFormsModule,
        MetricValuesSelectorComponent,
        TimeframeSelectorComponent,
    ],
    providers: [
        MoveDataGridRowService,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA,
    ],
})
export class DataGridModule {}
